import type { UIEvent } from 'react';
import { useCallback } from 'react';

import { app } from 'core';
import { NotFoundBoleto } from 'ui/components';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';

const NotFoundBankSlip = () => {
  const { trackClick } = app.commands.useAppCommand();
  const { redirectToHome } = useRedirectToHome();
  const handleReloadPage = (event: UIEvent<HTMLButtonElement>) => {
    trackClick(event);
    window.location.reload();
  };

  const handleClickToHome = useCallback((event: UIEvent<HTMLButtonElement>) => {
    trackClick(event);
    redirectToHome();
  }, []);

  return <NotFoundBoleto onClickReload={handleReloadPage} onClickToHome={handleClickToHome} />;
};

export default NotFoundBankSlip;
